<ac-layer acFor="let html of htmls$" [context]="this">
    <ac-html-desc props="{position: html.position, show: html.show}">
        <ng-template let-html>
            <div
                class="popup-close"
                (click)="closePopup()"
                *ngIf="html.id != '0'"
            >
                X
            </div>
            <div class="pop-up" *ngIf="html.id != '0'">
                <div class="popup-row">
                    <div class="popup-title">Number of samples:</div>
                    <div class="popup-value">{{ html.data.sampleCount }}</div>
                </div>
                <div class="popup-row">
                    <div class="popup-title">Number of measurements:</div>
                    <div class="popup-value">{{ html.data.measureCount }}</div>
                </div>
                <div class="popup-row"></div>
                <div class="popup-row">
                    <button [disabled]="html.data.sampleCount === 0" class="btn btn-primary"  (click)="openDialog()">
                        Download selected data {{html.data | json}}
                    </button>
                </div>
            </div>
            <div
                id="container"
                *ngIf="html.data.showDialog"
                class="display-dialog"
            >
                <div class="dialog">
                    <div *ngComponentOutlet="html.activeComponent"></div>
                </div>
            </div>
        </ng-template>
    </ac-html-desc>
</ac-layer>
